/**
 * 모니터링 API
 */

import { api } from './client';
import type { SystemStats } from '../../types/api.types';

export const monitoringApi = {
  /**
   * 대시보드 통계 조회
   */
  getDashboardStats: async (): Promise<SystemStats> => {
    const response = await api.get<SystemStats>('/api/v1/monitoring/dashboard/stats');
    return response;
  },

  /**
   * 시스템 상태 확인
   */
  checkHealth: async (): Promise<{ status: string }> => {
    const response = await api.get<{ status: string }>('/health');
    return response;
  },
};
